// extracted by mini-css-extract-plugin
module.exports = {"backElement":"BackButton_backElement__2g10t","arrow":"BackButton_arrow__t6EVb"};